import { createApp, reactive } from "vue";
// import BootstrapVueNext from 'bootstrap-vue-next';
import 'bootstrap/dist/css/bootstrap.css';
// import { BootstrapVueNext } from 'bootstrap-vue-next'

import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import globalUtils from '@/utils/globalUtils.js';
import CarregarPessoaFisica from '@/components/modals/CarregarPessoaFisica.vue';
import CarregarPessoa from '@/components/modals/CarregarPessoa.vue';
import App from "./App.vue";
import router from "./router";
import axios from "@/services/axios";
import { publicAxios } from '@/services/publicAxios';
import { isPublicRoute } from '@/router/publicRoute';
import "./assets/styles.css";
import Vue3Toastify, { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import LoadingSpinner from '@/utils/LoadingSpinner.vue';
import alertPlugin from './plugins/alertPlugin';
import { safeHtmlDirective } from '@/utils/safeHtml';
import permissionMixin from '@/permissionMixin.js';

axios.defaults.baseURL = process.env.VUE_APP_API_URL || '/api';
if (import.meta?.env?.MODE !== 'production') {
  window.axios = axios; // só em dev/hmg
}

// console.log('axios baseURL =', axios.defaults.baseURL);

const app = createApp(App);
app.directive('safe-html', safeHtmlDirective);

app.mixin(permissionMixin);

app.config.warnHandler = (msg, instance, trace) => {
  if (msg.includes('injection "___BVN__ID__modalManager__plugin__" not found')) {
    return;
  }
  console.warn(msg, instance, trace);
};

app.component('LoadingSpinner', LoadingSpinner);

export const globalState = reactive({
  logoPath: "",
  backgroundPath: "",
  permissionsLoaded: false,
  userPermissions: [],
  userName: "",
  userProfile: "",
  userId: null,
});

// registre cedo
app.config.globalProperties.$globalState = globalState;
app.config.globalProperties.$utils = globalUtils;
window.$globalState = app.config.globalProperties.$globalState;

app.component('CarregarPessoaFisica', CarregarPessoaFisica);
app.component('CarregarPessoa', CarregarPessoa);

// (opcional) expor no console para debug
window.$globalState = app.config.globalProperties.$globalState;


axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


function normalizeProfile(p) {
  const s = String(p || '').trim().toLowerCase();

  // aceita variações comuns
  if (s === 'admin' || s === 'administrator' || s === 'administrador') return 'administrador';
  if (s === 'instrutor') return 'instrutor';
  if (s === 'instrutor supervisor' || s === 'supervisor' || s === 'instrutor_supervisor') return 'instrutor supervisor';
  if (s === 'recepcao' || s === 'recepção' || s === 'recepcionista') return 'recepção';

  return s; // fallback (melhor logar no console se vier algo inesperado)
}


// Função para carregar userProfile
async function loadUserProfile({ silent = false } = {}) {
  // 0) tenta usar cache antes (evita UI vazia)
  const cachedProfile = localStorage.getItem('userProfile');
  if (cachedProfile) {
    globalState.userProfile = normalizeProfile(cachedProfile);
  }

  try {
    const response = await axios.get('/auth/user');
    const { id, name, profile } = response.data;

    globalState.userId      = id ?? null;
    globalState.userName    = name ?? '';
    globalState.userProfile = normalizeProfile(profile);

    localStorage.setItem('userProfile', globalState.userProfile);
  } catch (error) {
    if (
      isPublicRoute(
        router.currentRoute.value
      )
    ) {
      return;
    }

    console.error("Erro ao carregar userProfile:", error);

    // Se não tem token, não força toast (evita poluição no login)
    const token = localStorage.getItem("token");
    if (!silent && token) {
      toast.error("Não foi possível carregar o perfil do usuário.");
    }

    localStorage.removeItem('userProfile');

    // Se já estiver no login, não redireciona de novo
    if (router.currentRoute.value.path !== '/login') {
      router.push('/login');
    }
  }
}

function ensurePublicReferrerPolicy() {
  if (
    !isPublicRoute(
      router.currentRoute.value
    ) ||
    typeof document ===
      'undefined'
  ) {
    return;
  }

  let meta =
    document.querySelector(
      'meta[name="referrer"]'
    );

  if (!meta) {
    meta =
      document.createElement(
        'meta'
      );

    meta.setAttribute(
      'name',
      'referrer'
    );

    document.head.appendChild(
      meta
    );
  }

  meta.setAttribute(
    'content',
    'no-referrer'
  );
}

async function initializeApp() {
  const publicRoute = isPublicRoute(router.currentRoute.value);
  const visualAxios = publicRoute ? publicAxios : axios;
  try {
    // 1) Constrói base ABSOLUTA a partir do axios do projeto
    const API_BASE = (visualAxios?.defaults?.baseURL || '').replace(/\/+$/, '');
    console.info('[main] publicAxios.baseURL =', API_BASE);

    // 2) Preserva o cliente público e a URL absoluta do caminho autenticado.
    const { data } = publicRoute
      ? await publicAxios.get('/configuracoes/empresa/visuais')
      : await axios.get(`${API_BASE}/configuracoes/empresa/visuais`);

    // 3) Monta as imagens como URLs ABSOLUTAS
    const v = Date.now();
    globalState.logoBytes  = data.logo_bytes ?? 0;
    globalState.fundoBytes = data.fundo_bytes ?? 0;
    globalState.logoPath       = `${API_BASE}/configuracoes/empresa/logomarca?v=${v}`;
    globalState.backgroundPath = `${API_BASE}/configuracoes/empresa/plano-fundo?v=${v}`;
  } catch (e) {
    if (
      !isPublicRoute(
        router.currentRoute.value
      )
    ) {
      console.error(
        'Erro ao carregar dados visuais:',
        e
      );
    }

    const API_BASE = (visualAxios?.defaults?.baseURL || '').replace(/\/+$/, '');
    const now = Date.now();
    globalState.logoPath       = `${API_BASE}/configuracoes/empresa/logomarca?v=${now}`;
    globalState.backgroundPath = `${API_BASE}/configuracoes/empresa/plano-fundo?v=${now}`;
  }
}

app.config.globalProperties.$utils = globalUtils;
app.config.globalProperties.$globalState = globalState;
app.config.globalProperties.$toast = toast;

const refreshAuthToken = async () => {
  if (
    isPublicRoute(
      router.currentRoute.value
    )
  ) {
    return;
  }

  const token = localStorage.getItem("token");
  if (!token) return;
  try {
    const response = await axios.post("/auth/refresh", {});
    const newToken = response.data.token;
    const payload = JSON.parse(atob(newToken.split(".")[1]));
    localStorage.setItem("token", newToken);
    localStorage.setItem("token_exp", payload.exp);
    console.log("Token renovado com sucesso");
    await loadUserProfile(); // Recarregar userProfile após renovação do token
  } catch (err) {
    console.error("Erro ao renovar o token:", err);
    toast.error("Sua sessão expirou. Faça login novamente.");
    localStorage.removeItem("token");
    localStorage.removeItem("token_exp");
    localStorage.removeItem("userProfile");
    router.push("/login");
  }
};

let activityTimeout;
const setupUserActivityMonitor = () => {
  const renewOnActivity = () => {
    clearTimeout(
      activityTimeout
    );

    if (
      isPublicRoute(
        router.currentRoute.value
      )
    ) {
      return;
    }

    activityTimeout =
      setTimeout(
        refreshAuthToken,
        60000
      );
  };
  window.addEventListener("mousemove", renewOnActivity);
  window.addEventListener("keydown", renewOnActivity);
  window.addEventListener("click", renewOnActivity);
};
setupUserActivityMonitor();

setInterval(() => {
  if (
    isPublicRoute(
      router.currentRoute.value
    )
  ) {
    return;
  }

  const tokenExp = localStorage.getItem("token_exp");
  if (tokenExp && Math.floor(Date.now() / 1000) > tokenExp) {
    toast.error("Sua sessão expirou. Faça login novamente.");
    localStorage.removeItem("token");
    localStorage.removeItem("token_exp");
    localStorage.removeItem("userProfile");
    if (router.currentRoute.value.path !== '/login') {
      router.push("/login").then(() => setTimeout(() => window.location.reload(), 100));
    }
  }
}, 60000);

// app.use(BootstrapVueNext);
app.use(Vue3Toastify, { autoClose: 3000, position: "top-right" });
app.use(alertPlugin);
app.use(router);

async function bootstrapApp() {
  await router.isReady();

  ensurePublicReferrerPolicy();

  await initializeApp();

  if (
    isPublicRoute(
      router.currentRoute.value
    )
  ) {
    globalState.userName = '';
    globalState.userProfile = '';
    globalState.userId = null;
  } else {
    // ✅ carrega perfil se houver token (senão, deixa seguir)
    const token =
      localStorage.getItem(
        "token"
      );

    if (token) {
      await loadUserProfile({
        silent: true
      });
    } else {
      // garante estado limpo
      globalState.userName = '';
      globalState.userProfile = '';
      globalState.userId = null;
    }
  }

  app.mount('#app');
}

bootstrapApp();
